class InAppLogger {
  constructor() {
    this.logs = [];
    this.listeners = new Set();
    this.maxLogs = 50;
    this.originalConsoleError = null;
    this.originalConsoleWarn = null;
    this.isIntercepting = false;
  }

  init() {
    if (this.isIntercepting) return;

    this.originalConsoleError = console.error;
    this.originalConsoleWarn = console.warn;

    console.error = (...args) => {
      this.addLog('error', args.map(arg => typeof arg === 'object' ? JSON.stringify(arg) : String(arg)).join(' '));
      if (this.originalConsoleError) {
        this.originalConsoleError.apply(console, args);
      }
    };

    console.warn = (...args) => {
      this.addLog('warn', args.map(arg => typeof arg === 'object' ? JSON.stringify(arg) : String(arg)).join(' '));
      if (this.originalConsoleWarn) {
        this.originalConsoleWarn.apply(console, args);
      }
    };

    this.isIntercepting = true;
  }

  addLog(type, message) {
    const timestamp = new Date().toISOString();
    const entry = { timestamp, type, message };
    this.logs.unshift(entry);
    if (this.logs.length > this.maxLogs) {
      this.logs.pop();
    }
    this.notify();
  }

  getLogs() {
    return [...this.logs];
  }

  clear() {
    this.logs = [];
    this.notify();
  }

  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  notify() {
    this.listeners.forEach(listener => listener(this.getLogs()));
  }

  destroy() {
    if (!this.isIntercepting) return;
    console.error = this.originalConsoleError;
    console.warn = this.originalConsoleWarn;
    this.isIntercepting = false;
  }
}

const loggerInstance = new InAppLogger();
export default loggerInstance;
